import { render, staticRenderFns } from "./CardSubheader.vue?vue&type=template&id=0f7ccd20&scoped=true&"
import script from "./CardSubheader.vue?vue&type=script&lang=js&"
export * from "./CardSubheader.vue?vue&type=script&lang=js&"
import style0 from "./CardSubheader.vue?vue&type=style&index=0&id=0f7ccd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ccd20",
  null
  
)

export default component.exports